import React from 'react';
import { Link } from 'react-router-dom';
import { useAppUserManager } from '../../hooks/useManagers';
import './header.scss';
import Navigation from './Navigation';
import ProfileNav from './ProfileNav';

const PublicHeader = () => {
  const appUserMgr = useAppUserManager();
  return (
    <header className={`header header-box-shadow`}>
      {appUserMgr?.GetGlobalAuthState()?.isAuthenticated ? <Navigation /> : <div>&nbsp;</div>}
      <a href="/" className={appUserMgr?.GetGlobalAuthState()?.isAuthenticated ? 'eepass-banner' : 'eepass-banner-homepage'} aria-label="EE PASS Home" title="EE PASS Home"></a>
      <ProfileNav />
    </header>
  );
}

export default PublicHeader;